<template>
	<ModalComponent ref="modalRef" classBody="bg-grey-10" :isHeader="false" :isFooter="false" :defaultOpen="true" :closeOnBackgroundClick="false">
		<div :class="`alert w-100 text-center p-5 ${alertClass}`"> 
			<div v-if="type == 'loading'" class="p-5">
				<Loader size_prop="10em" />
			</div>

			<div v-else class="">
				<div v-if="showIcon == true" class="flex justify-center mb-2">
					<IconCheck v-if="type == 'success'" />
					<IconInformation v-else :color_prop="colorIcon" />
				</div>

				<div class="text-1.5xl font-bold mb-2">{{ title }}</div>

				<div class="text-base text-white mb-8" v-html="description"></div>

				<!-- Sell Warning -->
				<div v-if="showSellWarning" class="mb-8">
					<div v-if="!store.state.glossaries.onProcessSettlement.body">
						<Loader size_prop="10em"></Loader>
					</div>

					<div v-else class="text-left">
						<div class="mb-3">{{ store.state.glossaries.onProcessSettlement.title }}</div>
						<MarkdownRenderer :content="store.state.glossaries.onProcessSettlement.body" />
					</div>
				</div>

				<!-- Checkbox confirmation -->
				<div v-if="withCheckbox" class="mb-5 text-left">
					<label class="flex flex--justify-content-start items-center text-white cursor-hover-pointer">
						<input type="checkbox" class="mr-3" v-model="disclaimerCheck">
						{{ checkboxMessage }}
					</label>
				</div>

				<!-- Banner -->
				<div v-if="showBanner" :class="`flex gap-3 ${bannerBackground} border-warning py-2 px-4 mb-2.5`">
					<div>
						<IconInfo2 height_prop="1.25rem" width_prop="1.25rem" :color_prop="bannerIconColor" />
					</div>
					<div class="text-xs text-black text-left">
						{{ bannerMessage }}
					</div>
				</div>

				<div v-if="type != 'confirm'">
					<!-- <ButtonBase text="Tutup" class="w-full" @click="close" /> -->
					<button :class="`btn c-btn-theme w-full ${buttonCloseClass}`" @click="close()">{{ buttonCloseText }}</button>
				</div>

				<div v-else :class="`flex ${buttonConfirmPosition == 'horizontal' ? 'justify-center' : 'flex-col'} gap-2`">
					<!-- <ButtonBase styleButton="error" typeButton="text" text="Batal" class="w-1/2" @click="close('decline')" />
				<ButtonBase styleButton="primary" typeButton="solid" text="Ya" class="w-1/2" @click="close('confirm')" /> -->
					<button :class="`btn outline grow bg-transparent ${buttonConfirmPosition == 'horizontal' ? 'order-first' : 'order-last'} ${buttonDeclineClass}`"
						@click="close('decline')">
						{{ buttonDeclineText }}
					</button>

					<!-- if withCheckbox and checkbox not checked then disabled -->
					<button :class="`btn c-btn-theme grow ${buttonConfirmClass}`" @click="close('confirm')" :disabled="withCheckbox && !disclaimerCheck">
						{{ buttonConfirmText }}
					</button>
				</div>
			</div>
		</div>
	</ModalComponent>
</template>

<script>
import store from '../../store'
import ModalComponent from '../ModalComponent.vue'

import IconCheck from '../icons/IconCheck.vue'
import IconInformation from '../icons/IconInformation.vue'
import IconInfo2 from '../icons/IconInfo2.vue'

import Loader from '../Loader.vue'
import MarkdownRenderer from '../MarkdownRenderer.vue'

export default {
	name: 'AlertComponent',

	components: {
		ModalComponent,
		IconCheck,
		IconInformation,
		Loader,
		IconInfo2,
		MarkdownRenderer
	},

	props: {
		type: {
			type: 'loading' | 'success' | 'error' | 'warning' | 'info' | 'confirm',
			default: 'success'
		},
		iconColor: {
			type: 'success' | 'error' | 'warning' | 'info' | 'confirm',
			default: 'success'
		},
		title: {
			type: String,
			default: 'Success'
		},
		description: {
			type: String,
			default: 'Success'
		},

		showIcon: {
			type: Boolean,
			default: true
		},

		// banner
		showBanner: {
			type: Boolean,
			default: false
		},
		bannerStyle: {
			type: 'info' | 'warning',
			default: 'info'
		},
		bannerMessage: {
			type: String,
			default: 'Meesage'
		},

		showSellWarning: {
			type: Boolean,
			default: false
		},

		withCheckbox: {
			type: Boolean,
			default: false
		},
		checkboxMessage: {
			type: String,
			default: 'I understand and agree to the terms and conditions'
		},

		buttonConfirmPosition: {
			type: 'horizontal' | 'vertical',
			default: 'horizontal'
		},
		buttonConfirmText: {
			type: String,
			default: 'Ya'
		},
		buttonDeclineText: {
			type: String,
			default: 'Batal'
		},
		buttonCloseText: {
			type: String,
			default: 'Tutup'
		},

		alertClass: {
			type: String,
			default: ''
		},
		buttonConfirmClass: {
			type: String,
			default: ''
		},
		buttonDeclineClass: {
			type: String,
			default: ''
		},
		buttonCloseClass: {
			type: String,
			default: ''
		}
	},

	data() {
		return {
			store: store,
			disclaimerCheck: false,
		}
	},

	computed: {
		colorIcon() {
			const iconColor = this.iconColor || this.type
			if (iconColor == 'success') {
				return getComputedStyle(document.documentElement).getPropertyValue('--color-success')
			} else if (iconColor == 'error') {
				return getComputedStyle(document.documentElement).getPropertyValue('--color-danger')
			} else if (iconColor == 'warning') {
				return getComputedStyle(document.documentElement).getPropertyValue('--color-warning')
			} else if (iconColor == 'info') {
				return getComputedStyle(document.documentElement).getPropertyValue('--color-theme')
			} else {
				return getComputedStyle(document.documentElement).getPropertyValue('--color-theme')
			}
		},

		bannerIconColor() {
			if (this.bannerStyle == 'info') {
				return getComputedStyle(document.documentElement).getPropertyValue('--color-theme')
			} else if (this.bannerStyle == 'warning') {
				return getComputedStyle(document.documentElement).getPropertyValue('--color-warning')
			}
		},
		bannerBackground() {
			if (this.bannerStyle == 'info') {
				return 'bg-white-2'
			} else if (this.bannerStyle == 'warning') {
				return 'bg-warning-light'
			}
		}
	},

	created() {
		if (!store.state.glossaries.onProcessSettlement.body) {
			store.dispatch('glossaries/setOnProcessSettlement')
		}
	},

	methods: {
		open({ type, title, message }) {
			this.$refs.modalRef.openModal()
		},
		close(acceptance) {
			this.$refs.modalRef.closeModal()
			if (acceptance === 'confirm') {
				this.$emit('confirm')
			} else if (acceptance === 'decline') {
				this.$emit('decline')
			} else if (this.type == 'loading') {
				this.$emit('closeLoading')
			} else {
				this.$emit('close')
			}
		},
	}

}
</script>

<style scoped>
.alert {
	max-width: 25rem;
	min-width: 25rem;
}
</style>
